import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GroupClassification, IGroupClassification } from '@app-model/group-classification';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';


@Injectable({
	providedIn: 'root'
})

export class AdminClassificationService {
  constructor(private http: HttpClient) {}

  saveGroup(groupClassification: GroupClassification): Observable<object> {
    return this.http.post(`${environment.api}/adminClassification/save`,groupClassification);
  }

  getGroup(idGroup): Observable<object> {
    return this.http.get(`${environment.api}/adminClassification/group/${idGroup}`)
      .pipe(map((response: any) => {
          if (response && response.active) {
            response.classifications = response.classifications.map(resp => {
              resp.userIds = resp.users.map(r => r.id);
              return resp;
            });
          }
          return response;
        })
      );
  }

  listGroups(): Observable<IGroupClassification[]> {
    return this.http.get<IGroupClassification[]>(`${environment.api}/adminClassification/listGroup`)
      .pipe(
        take(1)
      );
  }

  listGroup(): Observable<object> {
    return this.http.get(`${environment.api}/adminClassification/listGroup`);
  }
  removeFilter(idFilter): Observable<object> {
    return this.http.delete(`${environment.api}/adminClassification/${idFilter}`,idFilter);
  }
}
